import {Menu} from "navigation-common/types/navigation-types";
import {navigationService} from "../api/NavigationService";
import {confluenceService} from "../api/ConfluenceService";
import {SessionStorageCache} from "../SessionStorageCache";

export interface MenuCacheItem {
    accountId: string,
    globalMenu?: Menu,
    spaceMenus: {
        [spaceKey: string]: Menu
    }
}

const CACHE_KEY_PREFIX = "myMenu-";

class MenuCache extends SessionStorageCache {

    async get(spaceKey?: string): Promise<Menu> {
        const contextData = confluenceService.getCurrentUserAndHost();

        const cachedMenu = await this.loadFromCache(contextData.accountId, contextData.clientKey, spaceKey);
        if (cachedMenu) {
            this.updateCache(contextData.accountId, contextData.clientKey, spaceKey);
            return cachedMenu;
        }

        const loadedMenu = await this.loadFromServer(spaceKey);
        this.updateCache(contextData.accountId, contextData.clientKey, spaceKey);
        return loadedMenu;
    }

    private async loadFromCache(accountId: string, hostInfo: string, spaceKey?: string) {
        const cachedMenu = this.getItem(this.buildCacheKey(hostInfo)) as MenuCacheItem;
        if (cachedMenu?.accountId !== accountId) {
            return undefined;
        }

        return spaceKey ? cachedMenu.spaceMenus[spaceKey] : cachedMenu.globalMenu;
    }

    private async loadFromServer(spaceKey?: string) {
        return navigationService.loadMyMenu(spaceKey);
    }

    private updateCache(accountId: string, hostInfo: string, spaceKey?: string) {
        this.loadFromServer(spaceKey).then((loadedMenu) => {
            this.setItem(this.buildCacheKey(hostInfo), this.buildMenuCacheItem(loadedMenu, accountId, spaceKey));
        });
    }

    private buildMenuCacheItem = (menu: Menu, accountId: string, spaceKey?: string): MenuCacheItem => {
        return {
            accountId,
            spaceMenus: {
                [spaceKey ?? ""]: menu
            },
            globalMenu: !spaceKey ? menu : undefined
        };
    }

    private buildCacheKey = (hostInfo: string) => {
        return CACHE_KEY_PREFIX + hostInfo;
    }
}

export const menuCache = new MenuCache();
